
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pillars/[slug]",
      function () {
        return require("private-next-pages/pillars/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pillars/[slug]"])
      });
    }
  